import { css } from "lit";
import { formSectionStyles } from "../live-event-form.css";

export const styles = [
  formSectionStyles,
  css`
    wow-input[type="date"],
    wow-input[type="time"] {
      --wow-input-padding: 10px 6px;
      --wow-input-padding-inline: 6px;
    }

    .input-icon-wrapper {
      position: relative;
      flex: 1 1 140px;
    }

    wow-select {
      --wow-input-label-white-space: normal;
    }

    .input-icon {
      position: absolute;
      right: 10px;
      top: 30px;
      height: var(--wow-input-height, 56px);
      display: flex;
      align-items: center;
      pointer-events: none;
      color: var(--sds-color-text-default-secondary);
      line-height: 0;
    }
  `,
];
